<app-loader [detectRouteTransitions]="true"></app-loader>
<router-outlet></router-outlet>

<button *ngIf="pwaInstallService.canInstall$ | async"
  (click)="pwaInstallService.installApp()"
  class="pwa-install-btn">
  ⬇ Install TPA App
</button>
